<template>
  <div>
    <div class="d-flex">
      <vs-radio
        v-model="input"
        :vsValue="val"
        :disabled="disabled"
        color="#A3CA76"
      >
        <strong>{{ label }}</strong>
      </vs-radio>
    </div>
    <div
      v-if="message"
      style="margin-left: 24px;"
    >
      <p>{{ message }}</p>
    </div>
  </div>
</template>

<script>
export default {
  props: ['value', 'val', 'label', 'message', 'disabled'],

  data () {
    return {
      input: null,
    }
  },

  watch: {
    input () {
      this.$emit('input', this.input)
    },
    value () {
      this.input = this.value
    },
  },

  created () {
    this.input = this.value
  },
}
</script>



// WEBPACK FOOTER //
// src/components/base/BaseRadioRich.vue